<script>
import flow from '@/flows';
import { VIEWS } from '@/common/constants.js';

export default {
  components: {
    configView: () => import(/* webpackChunkName: "config" */ '@/views/config'),
    compoundView: () => import(/* webpackChunkName: "compound" */ '@/views/compound'),
    modalView: () => import(/* webpackChunkName: "modal" */ '@/views/modal/index.vue'),
  },
  data() {
    return {
      VIEWS,
    };
  },
  computed: {
    view() {
      const view = flow.view();
      return view;
    },
  },
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};

    if (this.$context?.is.modal) {
      return <modalView { ...context} viewModel={this.view} />;
    }

    if (this.view === VIEWS.CONFIG) {
      return <configView { ...context} />;
    }

    if (this.view === VIEWS.COMPOUND) {
      return <compoundView { ...context} />;
    }

    return null;
  }
};
</script>
